var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5716 7.71416H16.2859C15.8125 7.71416 15.4287 8.09792 15.4287 8.57133C15.4287 9.04473 15.8125 9.42849 16.2859 9.42849H20.5716C21.045 9.42849 21.4288 9.81225 21.4288 10.2857V21.4286C21.4288 21.902 21.045 22.2858 20.5716 22.2858H3.42863C2.95522 22.2858 2.57146 21.902 2.57146 21.4286V10.2856C2.57146 9.8122 2.95522 9.42844 3.42863 9.42844H7.71436C8.18776 9.42844 8.57152 9.04469 8.57152 8.57128C8.57152 8.09787 8.18776 7.71411 7.71436 7.71411H3.42863C2.00845 7.71411 0.857178 8.86539 0.857178 10.2856V21.4285C0.857178 22.8487 2.00845 24 3.42863 24H20.5716C21.9918 24 23.143 22.8487 23.143 21.4285V10.2856C23.143 8.86544 21.9918 7.71416 20.5716 7.71416Z",
    fill: "#3A5273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8918 4.53671L12.6061 0.25098C12.2714 -0.08366 11.7288 -0.08366 11.3941 0.25098L7.10828 4.53671C6.77941 4.87723 6.78885 5.41984 7.12937 5.74871C7.46155 6.06953 7.98814 6.06953 8.32032 5.74871L11.1429 2.92609V17.1428C11.1429 17.6162 11.5267 18 12.0001 18C12.4735 18 12.8573 17.6162 12.8573 17.1428V2.92614L15.6799 5.74876C16.0204 6.07762 16.563 6.06818 16.8919 5.72766C17.2126 5.39548 17.2126 4.86889 16.8918 4.53671Z",
    fill: "#3A5273"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.fa1e22e07e873d238abb08db42c98893.svg";
export { ForwardRef as ReactComponent };